import type {
  CroListQuery,
  PersonnelListQuery,
  SponsorListQuery,
  TrialListQuery,
  TrialParticipantsQuery,
} from '@ctms/contracts';

/** One page is enough for the on-screen sponsor/CRO pickers (API max is 100). */
export const DICTIONARY_LIST_QUERY = { page: 1, limit: 100 } as const satisfies SponsorListQuery;

/** Contact cards for the team picker. Same page size as the dictionary pickers. */
export const PERSONNEL_CARD_LIST_QUERY = { page: 1, limit: 100 } as const satisfies PersonnelListQuery;

export const trialQueryKeys = {
  all: ['trials'] as const,
  lists: () => [...trialQueryKeys.all, 'list'] as const,
  list: (filters: TrialListQuery) => [...trialQueryKeys.lists(), filters] as const,
  details: () => [...trialQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...trialQueryKeys.details(), id] as const,
  visits: (trialId: number) => [...trialQueryKeys.all, 'visits', trialId] as const,
  /** Visit groups of one trial (#40) — the wizard's „Grupa" picker and A4b dialog. */
  visitGroups: (trialId: number) => [...trialQueryKeys.all, 'visit-groups', trialId] as const,
  /** Per-mode visit-window ranges of one visit (#36). */
  windowModes: (trialId: number, visitId: number) =>
    [...trialQueryKeys.all, 'visits', trialId, 'window-modes', visitId] as const,
  /** Qualification criteria configuration of one trial (issue #30). */
  criteria: (trialId: number) => [...trialQueryKeys.all, 'criteria', trialId] as const,
  /** Participant list of one trial — keyed by trial AND filters so a new filter reloads the list. */
  enrollments: (trialId: number, filters: TrialParticipantsQuery) =>
    [...trialQueryKeys.all, 'enrollments', trialId, filters] as const,
  allEnrollments: (trialId?: number) =>
    trialId !== undefined
      ? ([...trialQueryKeys.all, 'enrollments', trialId] as const)
      : ([...trialQueryKeys.all, 'enrollments'] as const),
  roles: (trialId: number) => [...trialQueryKeys.all, 'roles', trialId] as const,
  team: (trialId: number) => [...trialQueryKeys.all, 'team', trialId] as const,
  personnelCards: (filters: PersonnelListQuery = PERSONNEL_CARD_LIST_QUERY) =>
    ['personnel', 'list', filters] as const,
  sponsors: {
    all: ['dictionaries', 'sponsors'] as const,
    list: (filters: SponsorListQuery = DICTIONARY_LIST_QUERY) =>
      [...trialQueryKeys.sponsors.all, 'list', filters] as const,
  },
  cros: {
    all: ['dictionaries', 'cros'] as const,
    list: (filters: CroListQuery = DICTIONARY_LIST_QUERY) =>
      [...trialQueryKeys.cros.all, 'list', filters] as const,
  },
};
